import { Col, Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { TableTmovShipper } from '../../../../components/Table';
import { SubTitle } from '../../../../components/Typography';
import {
  formatarCnpjCpfIMask,
  formatarMoedaIMask,
} from '../../../../helpers/formatador';
import { Modal } from '../../../../styles/global';
import { Button, Text, Title } from './styles';

export default function ModalFrete({ lotesIntegracao, updateDadosCsv }) {
  const [freteSelecionado, setFreteSelecionado] = useState([]);

  const onRadioChange = (key, tipoFrete) => {
    const dadosFrete = lotesIntegracao.find(({ index }) => index === key);

    freteSelecionado[key] = tipoFrete;
    dadosFrete.freteInserido = tipoFrete;

    setFreteSelecionado([...freteSelecionado]);
  };

  const onOk = () => {
    const dadosFreteCalculado = lotesIntegracao.map(dadoFrete => ({
      ...dadoFrete,
      freteMotorista:
        dadoFrete.freteInserido === 'freteMotorista'
          ? dadoFrete.freteMotorista
          : 0,
      freteTotal:
        dadoFrete.freteInserido === 'freteTotal' ? dadoFrete.freteTotal : 0,
    }));

    updateDadosCsv(dadosFreteCalculado);
  };

  const columns = [
    {
      width: '20%',
      title: 'Pagador (CNPJ)',
      dataIndex: 'cnpjClientePagador',
      key: 'cnpjClientePagador',
      align: 'center',
      render: text => formatarCnpjCpfIMask(text),
    },
    {
      title: 'Produto',
      dataIndex: 'produto',
      key: 'produto',
      align: 'center',
    },
    {
      title: 'Cidade - UF Origem',
      dataIndex: 'cidadeOrigem',
      key: 'cidadeOrigem',
      align: 'center',
      render: (_, record) => (
        <>
          <SubTitle className="capitalize">
            {record.cidadeColeta || record.cidadeOrigem}
          </SubTitle>
        </>
      ),
    },
    {
      title: 'Cidade - UF Destino',
      dataIndex: 'cidadeDestino',
      key: 'cidadeDestino',
      align: 'center',
      render: (_, record) => (
        <>
          <SubTitle className="capitalize">
            {record.cidadeEntrega || record.cidadeDestino}
          </SubTitle>
        </>
      ),
    },
    {
      title: 'Frete Motorista',
      dataIndex: 'freteMotorista',
      key: 'freteMotorista',
      align: 'center',
      render: (text, record) => (
        <>
          <Radio
            checked={record.freteInserido === 'freteMotorista'}
            onChange={() => onRadioChange(record.index, 'freteMotorista')}
          >
            <Row justify="center">
              <Col>
                {formatarMoedaIMask(record.freteMotoristaPj)}
                &nbsp;(PJ)
              </Col>
              <Col>
                {formatarMoedaIMask(record.freteMotoristaPf)}
                &nbsp;(PF)
              </Col>
            </Row>
          </Radio>
        </>
      ),
    },
    {
      title: 'Frete Total',
      dataIndex: 'freteTotal',
      key: 'freteTotal',
      align: 'center',
      render: (text, record) => (
        <>
          <Radio
            checked={record.freteInserido === 'freteTotal'}
            onChange={() => onRadioChange(record.index, 'freteTotal')}
          >
            <Row justify="center">
              <Col>
                {formatarMoedaIMask(record.freteTotalPj)}
                &nbsp;(PJ)
              </Col>
              <Col>
                {formatarMoedaIMask(record.freteTotalPf)}
                &nbsp;(PF)
              </Col>
            </Row>
          </Radio>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Frete para cálculo"
        width={750}
        visible={true}
        closable={false}
        destroyOnClose={true}
        footer={[
          <Button key="submit" onClick={onOk} borderradius="4px">
            Enviar
          </Button>,
        ]}
      >
        <Row justify="center">
          <Title>Qual valor de frete deseja utilizar?</Title>
          <Text>
            Identificamos lotes que possuem valores de frete motorista e frete
            total. Selecione qual valor deseja considerar para a base de
            cálculos.
          </Text>
        </Row>
        <TableTmovShipper
          className="pt-30"
          colpadding="10px"
          rowKey="index"
          dataSource={lotesIntegracao.filter(
            ({
              freteTotalPj,
              freteMotoristaPj,
              freteTotalPf,
              freteMotoristaPf,
            }) =>
              (freteTotalPj > 0 && freteMotoristaPj > 0) ||
              (freteTotalPf > 0 && freteMotoristaPf > 0)
          )}
          pagination={false}
          columns={columns}
        />
      </Modal>
    </>
  );
}

ModalFrete.propTypes = {
  lotesIntegracao: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateDadosCsv: PropTypes.func.isRequired,
};
